import PropTypes from 'prop-types'
import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import Button from '@/components/Button'
import Card from '@/components/Card'
import { Copy, Plus } from '@/components/Icons'
import KeyValue from '@/components/KeyValue'

import './index.scss'

import CopyToClipboard from 'react-copy-to-clipboard'

import messages from './messages'

class AccountManagementConnector extends Component<any, any> {
  static displayName = 'AccountManagementConnector'

  static propTypes = {
    identityProvider: PropTypes.object,
    isScimAddInProgress: PropTypes.bool,
    isScimDeleteInProgress: PropTypes.bool,
    accountManagementConnector: PropTypes.shape({
      clientCredential: PropTypes.shape({
        clientId: PropTypes.string,
        clientSecret: PropTypes.string
      }),
      id: PropTypes.string,
      type: PropTypes.string
    }),
    apiHost: PropTypes.string.isRequired,
    onCreate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    scimToken: PropTypes.shape({ id: PropTypes.string, issuer: PropTypes.string, scimToken: PropTypes.string })
  }

  static defaultProps = {
    identityProvider: null,
    isScimAddInProgress: false,
    isScimDeleteInProgress: false,
    accountManagementConnector: null,
    scimToken: null
  }

  onDelete = () => {
    const accountManagementConnectorId = this.props.accountManagementConnector
      ? this.props.accountManagementConnector.id
      : null
    const scimId = this.props.scimToken ? this.props.scimToken.id : null
    return this.props.onDelete(accountManagementConnectorId, scimId)
  }

  render() {
    return (
      <Card
        className="account-management-wrapper"
        isActionInProgress={this.props.isScimAddInProgress || this.props.isScimDeleteInProgress}
      >
        <Card.Header title={<FormattedMessage {...messages.title} />} />
        <Card.Content>
          {this.props.accountManagementConnector || this.props.scimToken ? (
            <>
              <KeyValue>
                <KeyValue.Label>
                  <FormattedMessage {...messages.scimURL} />
                </KeyValue.Label>
                <KeyValue.Value>{`${this.props.apiHost}/scim/v2`}</KeyValue.Value>
              </KeyValue>
              {this.props.accountManagementConnector && (
                <div>
                  <div>
                    <KeyValue>
                      <KeyValue.Label>
                        <FormattedMessage {...messages.clientId} />
                      </KeyValue.Label>
                      <KeyValue.Value className="copy_icon">
                        {this.props.accountManagementConnector.clientCredential.clientId}
                      </KeyValue.Value>
                      <CopyToClipboard text={this.props.accountManagementConnector.clientCredential.clientId}>
                        <div className="copy-to-clipboard">
                          <Copy /> <FormattedMessage {...messages.copy} />
                        </div>
                      </CopyToClipboard>
                    </KeyValue>
                  </div>
                  <div>
                    {this.props.accountManagementConnector.clientCredential.clientSecret && (
                      <KeyValue>
                        <KeyValue.Label>
                          <FormattedMessage {...messages.secret} />{' '}
                          <span className="warning">
                            <FormattedMessage {...messages.onlyDisplayedOnce} />
                          </span>{' '}
                        </KeyValue.Label>
                        <KeyValue.Value className="copy_icon">
                          {this.props.accountManagementConnector.clientCredential.clientSecret}
                        </KeyValue.Value>
                        <CopyToClipboard text={this.props.accountManagementConnector.clientCredential.clientSecret}>
                          <div className="copy-to-clipboard">
                            <Copy /> <FormattedMessage {...messages.copy} />
                          </div>
                        </CopyToClipboard>
                      </KeyValue>
                    )}
                  </div>
                </div>
              )}
              {this.props.scimToken && this.props.scimToken.scimToken && (
                <div>
                  <hr className="access_token__divider" />
                  <KeyValue>
                    <KeyValue.Label>
                      <FormattedMessage {...messages.accessToken} />{' '}
                      <span className="warning">
                        <FormattedMessage {...messages.onlyDisplayedOnce} />
                      </span>{' '}
                    </KeyValue.Label>
                    <KeyValue.Value className="copy_icon scim_wrapper">{this.props.scimToken.scimToken}</KeyValue.Value>
                    <CopyToClipboard text={this.props.scimToken.scimToken}>
                      <div className="copy-to-clipboard">
                        <Copy /> <FormattedMessage {...messages.copy} />
                      </div>
                    </CopyToClipboard>
                  </KeyValue>
                </div>
              )}
            </>
          ) : (
            <p>
              <FormattedMessage {...messages.description} />
            </p>
          )}
        </Card.Content>
        <Card.Footer>
          {!this.props.accountManagementConnector && !this.props.scimToken ? (
            <div style={{ float: 'right' }}>
              <Button color="primary" onClick={this.props.onCreate}>
                <>
                  {' '}
                  <Plus />
                  <FormattedMessage {...messages.create} />
                </>
              </Button>
            </div>
          ) : (
            <div style={{ float: 'right' }}>
              <Button color="secondary" onClick={this.onDelete} className="no-right-margin">
                <FormattedMessage {...messages.reset} />
              </Button>
            </div>
          )}
        </Card.Footer>
      </Card>
    )
  }
}

export default AccountManagementConnector
